module.exports = "/images/search-v5.svg";